<template>
  <Dialog :model-value="modelValue" @update:modelValue="$emit('update:modelValue', $event)" @close="$emit('close')" size="large">
    <div class="reward-dialog" :class="cssType">
      <Prop v-for="(item, index) in props.propList" :key="index" :item="item" />
    </div>
  </Dialog>
</template>

<script setup>
import { isMobile } from '@/utils'
import { defineProps } from 'vue'
import Dialog from '@/components/Dialog/ActPoolParty/index.vue'
import Prop from '@/views/act/poolParty/components/Prop/index.vue'
const cssType = isMobile ? 'mobile' : 'pc'
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  propList: {
    type: Array,
    default: () => []
  }
})
</script>

<style lang="less" scoped src="./mobile_style.less"></style>
<style lang="less" scoped src="./pc_style.less"></style>